import React from "react";
import { Dropdown } from "primereact/dropdown";
import countryData from "../../Country/country.json";
import { useTranslation } from "react-i18next";

const UserProfileCountry = ({
  fieldLabel,
  placeholder,
  name,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const valueTemplate = (option, props) => {
    if (option) {
      return (
        <div className="d-flex align-items-center">
          <img
            src={option.flag}
            alt={option.name}
            style={{ width: "24px", marginRight: "10px" }}
          />
          {t(`${option.code}.country.label`)}
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const itemTemplate = (option) => {
    return (
      <div className="d-flex align-items-center">
        <img
          src={option.flag}
          alt={option.name}
          style={{ width: "24px", marginRight: "10px" }}
        />
        {t(`${option.code}.country.label`)}
      </div>
    );
  };

  return (
    <div className="form-group col-xl-12">
      <label className="me-sm-2">{fieldLabel}</label>
      <Dropdown
        id={name}
        name={name}
        value={value}
        options={countryData}
        onChange={onChange}
        optionLabel="name"
        optionValue="code"
        className="w-100"
        filter
        filterBy="name"
        placeholder={t("select.label")}
        valueTemplate={valueTemplate}
        itemTemplate={itemTemplate}
      />
    </div>
  );
};

export default UserProfileCountry;
